import { render, staticRenderFns } from "./OwnProfile.vue?vue&type=template&id=4eeae953&"
import script from "./OwnProfile.vue?vue&type=script&lang=js&"
export * from "./OwnProfile.vue?vue&type=script&lang=js&"
import style0 from "./OwnProfile.vue?vue&type=style&index=0&id=4eeae953&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports